import { createServerFn } from '@tanstack/react-start'

import {
    resolveMaintenanceExtensionRequestInputSchema,
    updateCompanyNameInputSchema,
    updateMaintenanceModeInputSchema,
    updateSystemLogoInputSchema,
} from '@/features/Admin/SystemSettings/validation.ts'
import { PERMISSIONS } from '@/lib/Permissions/permissions.ts'
import { getSystemSettingsService } from '@/server/Admin/SystemSettings/get.service.ts'
import {
    resolveMaintenanceExtensionRequestService,
    updateSystemLogoService,
    updateMaintenanceModeService,
    updateCompanyNameService,
} from '@/server/Admin/SystemSettings/update.service.ts'
import { requirePermissionService } from '@/server/Auth/authorization.service.ts'

async function requireSystemSettingsPermission() {
    await requirePermissionService(PERMISSIONS.ADMIN_SYSTEM_SETTINGS)
}

export const getSystemSettingsHandler = createServerFn({
    method: 'GET',
}).handler(async function () {
    return getSystemSettingsService()
})

export const updateCompanyNameHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return updateCompanyNameInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        await requireSystemSettingsPermission()
        return updateCompanyNameService(data)
    })

export const updateSystemLogoHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return updateSystemLogoInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        await requireSystemSettingsPermission()
        return updateSystemLogoService(data)
    })

export const updateMaintenanceModeHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return updateMaintenanceModeInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        await requireSystemSettingsPermission()
        return updateMaintenanceModeService(data)
    })

export const resolveMaintenanceExtensionRequestHandler = createServerFn({
    method: 'POST',
})
    .validator(function (data: unknown) {
        return resolveMaintenanceExtensionRequestInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        await requireSystemSettingsPermission()
        return resolveMaintenanceExtensionRequestService(data)
    })
